import { render, staticRenderFns } from "./ApiPostback.pug?vue&type=template&id=2530acc0&scoped=true&lang=pug&"
import script from "./ApiPostback.vue?vue&type=script&lang=js&"
export * from "./ApiPostback.vue?vue&type=script&lang=js&"
import style0 from "./ApiPostback.scss?vue&type=style&index=0&id=2530acc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530acc0",
  null
  
)

export default component.exports